import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { ShareCard } from "../components/celebrate/ShareCard";
import { ShareButtons } from "../components/celebrate/ShareButtons";
import { fireConfetti } from "../components/celebrate/CelebrationDialog";

export default function PublishedCard() {
  const { token } = useParams();
  const [c, setC] = useState(null);
  const [missing, setMissing] = useState(false);
  useEffect(() => {
    api.get(`/public/celebrations/${token}`).then((r) => { setC(r.data); fireConfetti(); }).catch(() => setMissing(true));
  }, [token]);
  return (
    <div className="min-h-screen grid place-items-center px-4 py-16" data-testid="published-card-page">
      <div className="w-full max-w-xl space-y-6">
        {missing && <div className="panel p-10 text-center" data-testid="published-card-missing"><p className="font-display text-2xl mb-2">Card not found</p><p className="text-sm text-slate-400">This link may have been removed.</p></div>}
        {!c && !missing && <div className="h-64 rounded-2xl bg-slate-900 animate-pulse" data-testid="published-card-loading" />}
        {c && <>
          <ShareCard c={c} />
          {c.showcase_slug && <Link to={`/authors/${c.showcase_slug}`} className="block text-center h-11 leading-[2.75rem] rounded-full bg-amber-600 hover:bg-amber-500 text-white text-sm transition-colors" data-testid="published-card-view-book">See the book →</Link>}
          <ShareButtons c={c} />
        </>}
        <p className="text-center text-xs text-slate-500">Made with <Link to="/" className="text-amber-300 hover:underline" data-testid="published-card-home">Production Studio</Link></p>
      </div>
    </div>
  );
}
